import { ContainerModule, interfaces } from "inversify";
import {
    AccountConfig,
    AccountConfigProvider,
    AccountConfigData,
    EnvironmentConfig,
    PublicConfigProvider,
    AccountSidOption,
    RuntimeDomainOption,
    PublicConfig,
    AccountConfigDataGetter,
    AccountConfigOptions,
    accountConfigRTTI,
    accountConfigProviderRTTI,
    environmentConfigRTTI,
    publicConfigProviderRTTI,
    configDataContainerRTTI,
    featuresProviderRTTI,
    getAccountConfigRTTI,
    accountConfigOptionsRTTI
} from "~/modules/config";
import { accountConfigProvider } from "./AccountConfigProvider/AccountConfigProvider";
import { accountConfigUpdaterRTTI } from "./config.rtti";
import { getEnvironmentConfig } from "./EnvironmentConfig/EnvironmentConfigImpl";
import { AccountConfigStore } from "./AccountConfig/AccountConfigImpl/AccountConfigStore/AccountConfigStore";
import { getPublicConfig } from "./PublicConfigProvider/getPublicConfig";
import { XOR } from "~/utils/utilityTypes";
import { updateAccountConfig } from "./AccountConfig/AccountConfigImpl/AccountConfigUpdate/updateAccountConfig";
import { ConfigDataContainer } from "./AccountConfig/ConfigDataContainer";
import { AccountConfigDataContainer } from "./AccountConfig/AccountConfigImpl/AccountConfigDataContainer/AccountConfigDataContainer";
import { AccountConfigUpdater } from "./AccountConfig/AccountConfigUpdater";
import { featuresProviderImpl } from "./FeaturesProvider/featuresProviderImpl/featuresProviderImpl";
import { FeaturesConfig, FeaturesProvider } from "./FeaturesProvider/FeaturesProvider";
import { getAccountConfigData } from "./AccountConfigDataGetter/getAccountConfigData";
import { getDefaultAccountConfigOptions } from "./AccountConfigOptions/getDefaultAccountConfigOptions";

export const configModuleContainer = new ContainerModule((bind: interfaces.Bind) => {
    bind<AccountConfig>(accountConfigRTTI).to(AccountConfigStore).inSingletonScope();
    bind<ConfigDataContainer<AccountConfigData>>(configDataContainerRTTI)
        .to(AccountConfigDataContainer)
        .inSingletonScope();
    bind<AccountConfigProvider>(accountConfigProviderRTTI).toProvider<AccountConfig>((context: interfaces.Context) =>
        accountConfigProvider(context.container)
    );
    bind<AccountConfigUpdater>(accountConfigUpdaterRTTI).toDynamicValue((context: interfaces.Context) => {
        return (accountSid: string, config: Partial<AccountConfigData>) =>
            updateAccountConfig(context.container, accountSid, config);
    });
    bind<EnvironmentConfig>(environmentConfigRTTI).toDynamicValue(getEnvironmentConfig);
    bind<PublicConfigProvider>(publicConfigProviderRTTI).toProvider<PublicConfig>((context: interfaces.Context) => {
        return (option: XOR<AccountSidOption, RuntimeDomainOption>) => getPublicConfig(context.container, option);
    });
    bind<FeaturesProvider>(featuresProviderRTTI).toProvider<FeaturesConfig>(featuresProviderImpl);
    bind<AccountConfigDataGetter>(getAccountConfigRTTI).toDynamicValue((context: interfaces.Context) =>
        getAccountConfigData(context.container)
    );
    bind<AccountConfigOptions>(accountConfigOptionsRTTI).toConstantValue(getDefaultAccountConfigOptions());
});
